import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import TransomConfigurator from './../TransomConfigurator';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class XC38Mast extends Component {
    constructor(props) {
        super(props);
        this.handleMastAndBoomChange = this.handleMastAndBoomChange.bind(this);
    }

    handleMastAndBoomChange(newValue) {
        let configuration = this.props.configuration;
        configuration.MastAndBoom = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 1800, height: 785 }} transform={
                [
                    0.056576, -0.011704, 0, -0.000061,
                    0.011961, 0.097409, 0, 0.000008,
                    0, 0, 1, 0,
                    214, 320, 0, 1
                ]}>
                <ConfiguratorImage boat="XC38" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Mast & boom' /></h1>

                    <h2><Trans defaults='Finish' /></h2>

                    <RadioGroup options={this.props.mastAndBoomOptions} value={this.props.configuration.MastAndBoom} onChange={this.handleMastAndBoomChange} />

                    <p><Trans defaults='**for optional furlerboom, please contact your local X-Yachts Dealer.' /></p>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XC38Mast);


// WEBPACK FOOTER //
// ./src/XC38/XC38Mast.js